// removed by extract-text-webpack-plugin
module.exports = {"table_ui":"h2RNV","table_add":"_3LP9_","table_delete":"l6bdK","root":"_2jblD","headline":"_1E2nk","headline_cont":"_6H6Hr","headline__btn":"_2ipjf _12TwT _3gxMh","headline__icon":"_3CVv_","table":"spPiu _300jB","delete":"_2nx4T l6bdK","highlight":"_3pETA","filter":"_2Bdv_"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/contacts/Contacts.css
// module id = 921
// module chunks = 0